/**
 *
 * @param {IconProps} props
 * @returns {React.JSX.Element}
 */
const XClose = ({svg_props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    viewBox="0 0 14 14"
    fill="none"
    {...svg_props}
  >
    <path
      d="M13 1 1 13M1 1l12 12"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default XClose;